import { render, staticRenderFns } from "./StaffCardSkeleton.vue?vue&type=template&id=d1645524&scoped=true"
import script from "./StaffCardSkeleton.vue?vue&type=script&lang=js"
export * from "./StaffCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./StaffCardSkeleton.vue?vue&type=style&index=0&id=d1645524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1645524",
  null
  
)

export default component.exports